export default "__VITE_ASSET__VbbNUBF1__"